import { useLazyQuery } from 'src/graphql';
import { SURVEY_SUMMARY_BY_CODE } from 'src/graphql/survey/query';

export default ({ code }) => {
  const [callback, { loading, error, data }] = useLazyQuery(SURVEY_SUMMARY_BY_CODE, {
    variables: { code },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
  return [callback, { loading, error, data }];
};
